import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {  WipData } from '.';


export class InventoryWipResponse extends GlobalResponseObject{
    data?: WipData[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //WipData
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: WipData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }    
}
